import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";




class App extends Component {
    constructor(props) {
        super(props);

        const { colorLine, history } = this.props

        this.state = {
            series: [
                {
                    // data: parseFloat(this.props.history).toFixed(2).toString()
                    data: history ? history.map(item => parseFloat(item).toFixed(2)) : [0, 0, 100, 89, 63, 25, 44, 12, 36, 9, 54]
                    // data: [0, 0, 100, 89, 63, 25, 44, 12, 36, 9, 54]

                }
            ],
            chartOptionsSparkLine: {
                chart: {
                    height: 30,
                    sparkline: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '0'
                    }
                },
                xaxis: {
                    crosshairs: {
                        width: 0
                    },
                },
                tooltip: {
                    fixed: {
                        enabled: false
                    },
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function (seriesName) {
                                return ''
                            }
                        }
                    },
                    marker: {
                        show: false
                    }
                },
                // colors: ['#F44336', '#E91E63', '#9C27B0']
                colors: [colorLine || '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    show: true,
                },
                stroke: {
                    show: true,
                    curve: 'smooth',
                    lineCap: 'butt',
                    colors: undefined,
                    width: 3,
                    dashArray: 0,
                }
            }
        };
    }

    render() {
        return (
            <ReactApexChart
                options={this.state.chartOptionsSparkLine}
                series={this.state.series}
                type="line" height='100%' width="100%"
            />
        );
    }
}

export default App;